var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{attrs:{"horizontal":""}},[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.imprint}},[_vm._v(" "+_vm._s(_vm.$t("imprint.title"))+" ")]),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.privacy}},[_vm._v(" "+_vm._s(_vm.$t("privacy.title"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }